// extracted by mini-css-extract-plugin
export default {"TaskPop":"TaskPop_TaskPop__PGx-s","mSpinner":"TaskPop_mSpinner__H5wdE"};